<main id="content-page">
    <div class=" main-panel">
        <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
        <article class="article-content">

                    <div class="article-wrap">
                        <div id="entryArea" class="article-inner-container" *ngIf="!examQuestion">
                            <article class="article-content">
                                <div *ngIf="canStartExam()" class="text-center">
                                    <h1>{{digitalBadgeCourseData.Information.Title}}</h1>
                                </div>
    
                                <div *ngIf="canStartExam()" id="examArea">
                                    <h3>Exam Summary</h3>
                                    Total Questions: {{digitalBadgeCourseData.TotalFinalExamQuestions}}<br />
                                    Time Limit: {{digitalBadgeCourseData.FinalExamTimeLimitMinutes}} minutes<br />
                                    <div class="small margin-top-5">
                                        Exam timer starts immediately after this screen
                                    </div>
                                    <hr />

                                    <input type="checkbox" id="accept" value="accept" /><label for="accept" style="margin-left: 5px" id="acceptMessage">I agree to start the exam now</label>
                                    <br />
                                    <div style="margin-top: 10px;">
                                        <button (click)="startExam()" class="btn btn-primary btn-lg" type="button">start exam</button>
                                    </div>
                                </div>
                                <span *ngIf="hasAnsweredAllQuestions()">
                                    <h4>You've already answered all questions</h4>
                                    <div style="height: 200px"></div>
                                </span>
                                <span *ngIf="hasPassed()">
                                    <h4>You've already passed this Exam</h4>
                                    <div style="height: 200px"></div>
                                </span>    
                            </article>
                        </div>
                        <div *ngIf="displayExam()" class="article-wrap">
                            <div class="row margin-bottom-10">
                                <div *ngIf="examQuestion" class="col-sm-12">
                                    {{examQuestion.Question.Text}}
                                </div>
                            </div>
                            <div *ngFor="let answer of ((examQuestion && examQuestion.Question) ? examQuestion.Question.Answers: [])" class="row">
                                <div class="col-sm-12 margin-left-40">
                                    <div class="radio">
                                        <label>
                                            <input (click)="clickRadio($event)" name="answerRadioBtn" type="radio" id="{{answer.ID}}">
                                            <span class="text">{{answer.Text}}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col-sm-12 col-md-6 margin-top-5 text-align-left">
                                    <strong id="TimeRemaining">Time Remaining: {{timeRemaining}}</strong>
                                </div>
                                <div class="col-sm-12 col-md-6 text-align-right">
                                    <button (click)="SkipQuestion()" class="btn btn-default btn-sm btn-skip" type="button">skip this question</button>
                                </div>
                            </div>
                            <hr />
                            <div style="margin-top: 10px;">
                                <button [disabled]="!answer" (click)="SubmitQuestion()" class="btn btn-primary btn-lg btn-save" type="button">submit</button>
                            </div>
                        </div>
                        <div *ngIf="displayExamOver()" class="article-wrap" >
                            <div class="row">
                                <div *ngIf="examQuestion.topic" class="col-sm-12"> 
                                    <h2>Success</h2>
                                    <h4>Congratulations!  You have completed the exam successfully and earned your digital badge in {{examQuestion.topic}}.  Once you accept this badge, you can easily add it to your LinkedIn profile or share your achievement on social media.</h4>
                                    <br />
                                    <a class="btn btn-block digital-badge-help-buttons" href="{{examQuestion.acceptBadgeUrl}}">Accept your digital badge now!</a>
                                    <hr />
                                </div>
                                <div *ngIf="!examQuestion.topic" class="col-sm-12"> 
                                    <h2>Failure</h2>
                                    <h4>You have failed this exam.  Do not worry - you can take the exam as many times as you like.  Better luck next time</h4>
                                    <hr />
                                </div>
                            </div>
                        </div>
                    </div>


        </article>
    </div>
</main>
